// blob
import '@babel/polyfill';

import { gsap } from "gsap";
import Scrollbar from 'smooth-scrollbar';
import * as THREE from '../../../node_modules/three/build/three.module';
gsap.install(window);
// gsap.install(window);

import { EffectComposer } from './vendor/three/three.js-master/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from './vendor/three/three.js-master/examples/jsm/postprocessing/RenderPass';
// import { GlitchPass } from './vendor/three/three.js-master/examples/jsm/postprocessing/GlitchPass';
import utils from './utils/utils';
import { UnrealBloomPass } from './vendor/three/three.js-master/examples/jsm/postprocessing/UnrealBloomPass';
// import fastReader from './fastreader';
export default function () {

	console.warn = function () { };
	let ismobile = utils.isMobile();

	var renderer = new THREE.WebGLRenderer({ precision: 'lowp', powerPreference: "high-performance", antialias: false, alphaTest: true }),
		body = document.querySelector('body'),
		composer;

	renderer.setPixelRatio(ismobile ? 2 : 1);
	renderer.setClearColor(0x000000, 0);
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.domElement.classList.add('canvas-main');
	body.appendChild(renderer.domElement);

	// Mouse/Touch interaction variables
	let mouse = new THREE.Vector2();
	let targetRotationX = 0;
	let targetRotationY = 0;
	let mouseX = 0;
	let mouseY = 0;

	// Add mouse/touch event listeners
	function onMouseMove(event) {
		mouseX = (event.clientX - window.innerWidth / 2);
		mouseY = (event.clientY - window.innerHeight / 2);
		mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
		mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

		targetRotationX = (mouseY * 0.00002);
		targetRotationY = (mouseX * 0.00002);
	}

	function onTouchMove(event) {
		if (event.touches.length === 1) {
			event.preventDefault();
			mouseX = event.touches[0].clientX - window.innerWidth / 2;
			mouseY = event.touches[0].clientY - window.innerHeight / 2;
			mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1;
			mouse.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1;
		}
	}

	window.addEventListener('mousemove', onMouseMove, false);
	window.addEventListener('touchmove', onTouchMove, false);

	window.addEventListener('resize', onWindowResize, false);
	function onWindowResize() {
		if (renderer.renderer3D)
			renderer.renderer3D.setSize(renderer.dom.clientWidth, renderer.dom.clientHeight);
		if (renderer.composer)
			renderer.composer.setSize(renderer.dom.clientWidth, renderer.dom.clientHeight);

		camera.aspect = window.innerWidth / window.innerHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(window.innerWidth, window.innerHeight);
	}

	var camera = new THREE.PerspectiveCamera(25, window.innerWidth / window.innerHeight, 1, 500);
	var scene = new THREE.Scene();

	composer = new EffectComposer(renderer);

	scene.fog = new THREE.FogExp2(0x130419, 0.15);
	camera.position.set(0, 0, 10);

	//--------------------------------------------------------------
	var group3d = new THREE.Object3D();
	var geometry = new THREE.BufferGeometry().fromGeometry(new THREE.IcosahedronGeometry(1, 1))

	var gparticular = new THREE.BufferGeometry().fromGeometry(new THREE.CircleGeometry(2.3, 3))
	var bparticular = new THREE.BufferGeometry().fromGeometry(new THREE.CircleGeometry(1, 3))

	// Enhanced materials with better visual properties
	var material = new THREE.MeshPhysicalMaterial({
		alphaTest: false,
		transparent: false,
		color: 0xFFFFFF,
		shading: THREE.FlatShading,
		side: THREE.DoubleSide,
		metalness: 1,
		roughness: 1.4,
		emissive: 0x221122
	});
	var bmaterial = new THREE.MeshNormalMaterial({ alphaTest: true, transparent: true, color: 0xFFFFFF, wireframe: false });
	var wmaterial = new THREE.MeshNormalMaterial({ alphaTest: true, transparent: true, color: 0xFFFFFF, wireframe: true });
	var pmaterial = new THREE.MeshNormalMaterial({ alphaTest: true, transparent: true, color: 0xFFFFFF, wireframe: false });

	let animTime = 1.5,
		cEase = 'elastic.out(1, 0.5)'

	function mathRandom(num = 3) {
		var mathnum = -Math.random() * num + Math.random() * num;
		return mathnum;
	}

	// Enhanced particle system
	let particles = [];
	let pscale, particular;
	for (var i = 1; i < 150; i++) {
		pscale = 0.02 + Math.abs(mathRandom(0.03));
		particular = new THREE.Mesh(gparticular, pmaterial);
		particular.position.set(0, 0, 0);

		particular.rotation.set(mathRandom(), mathRandom(), mathRandom());
		particular.scale.set(pscale, pscale, pscale);

		particular.position.x = mathRandom(8);
		particular.position.y = mathRandom(8);
		particular.position.z = mathRandom(8);

		// Store original position for animation
		particular.userData = {
			originalX: particular.position.x,
			originalY: particular.position.y,
			originalZ: particular.position.z,
			speed: Math.random() * 0.0000001 + 0.0000001
		};

		particles.push(particular);
		group3d.add(particular);
	}



	// MAKE CUBE & SQUARE
	var cube = new THREE.Mesh(geometry, material);
	var wcube = new THREE.Mesh(geometry, wmaterial);
	var bcube = new THREE.Mesh(bparticular, bmaterial);

	bcube.scale.set(0.0001, 0.0001, 0.0001);
	cube.scale.set(0.0001, 0.0001, 0.0001);
	bcube.position.z = - 1;
	cube.position.z = - 2;
	cube.position.x = 3;


	// var ambientLight = new THREE.AmbientLight(0x777777, 0.2);
	var ambientLight = new THREE.AmbientLight(0x404040, 0.3);
	var lightFront = new THREE.PointLight('#EA0AEA', 1.2);
	var lightBack = new THREE.PointLight('#4ed0fe', 1.2);
	var lightSide = new THREE.PointLight('#ff6b6b', 0.8);

	lightFront.castShadow = false;

	lightFront.position.set(10, 10, 5);
	lightBack.position.set(-5, -10, -5);
	lightSide.position.set(0, 0, 10);



	renderer.setClearColor('#130419', 1);
	// ADD ELEMENTS TO SCENE

	// scene.add(ambientLight);
	scene.add(lightBack);
	scene.add(lightFront);
	// scene.add(lightSide);
	scene.add(ambientLight);
	scene.add(group3d);
	cube.add(wcube);
	scene.add(bcube);
	scene.add(cube);

// gsap animate lights
	gsap.to(lightFront.position, {
		duration: 6,
		x: -10,
		y: -10,
		repeat: -1,
		yoyo: true,
		ease: "sine.inOut"
	});
	gsap.to(lightBack.position, {
		duration: 8,
		x: 5,
		y: 10,
		repeat: -1,
		yoyo: true,
		ease: "sine.inOut"
	});
	gsap.to(lightSide.position, {
		duration: 7,
		x: 0,
		y: -5,
		repeat: -1,
		yoyo: true,
		ease: "sine.inOut"
	});


	// Add raycaster for hover effects
	var raycaster = new THREE.Raycaster();
	var hoveredObject = null;

	function updateHoverEffects() {

	}

	// PREPARE FOR POSTPROCESSING

	var renderScene = new RenderPass(scene, camera);
	composer.addPass(renderScene);

	if (!ismobile) {
		// MAK STUFF GLOW
		var bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 1.5, 0.4, 0.85);

		var params = {
			exposure: 1,
			bloomStrength: 1.5,
			bloomThreshold: 0.1,
			bloomRadius: 1.1
		};
		bloomPass.threshold = params.bloomThreshold;
		bloomPass.strength = params.bloomStrength;
		bloomPass.radius = params.bloomRadius;

		composer.addPass(bloomPass);
	}

	// MAK STUFF SHAKE
	// var glitchPass = new GlitchPass(1);
	// composer.addPass(glitchPass);
	// glitchPass.enabled = false;

	function rev(str) {
		return parseFloat('-' + str) + 2.5;
	}


	const resetMainCanvas = (pos) => {
		isIntro = true;
		isIntroBlob = false;
		if (about == true) {
			return;
		}
		if (pmaterial.opacity < 0.9) {

			TweenMax.to(pmaterial, animTime, {
				opacity: 1, ease: cEase
			});
		}

		TweenMax.to(bcube.position, animTime, {
			x: 0, y: 0.2, ease: cEase,
		})
		TweenMax.to(bcube.scale, animTime, { x: rev(pos.y / 1.2), y: rev(pos.y / 1.2), z: rev(pos.y / 1.2), ease: cEase })
		TweenMax.to(bcube.rotation, animTime, { z: + pos.y + 4.7 * Math.PI / 180, ease: cEase })

	}

	let isIntro = false, isIntroBlob = false, ilastpox, ilastpoy;
	const introBlob = (pos) => {
		if (about != false || isIntroBlob == true) {
			return;
		}
		isIntroBlob = true

		TweenMax.to(cube.position, animTime, {
			x: pos.x + 4 + (ismobile ? pos.y * 1 : pos.y * 2), y: pos.y, z: 0, ease: cEase
		});

		if (cube.scale.x < 0.4 || cube.scale.x > 0.4) {

			TweenMax.to(cube.scale, animTime,
				{
					x: 0.4, y: 0.4, z: 0.4,
					ease: cEase,

				})

			if (pmaterial.opacity == 0.5) {
				TweenMax.to(pmaterial, animTime, {
					opacity: 1, ease: cEase
				});
			}
		}

	}

	let about = false;
	const moveToAboutTriangle = function (pos) {
		about = true;
		if (isIntro == true || workTriangle == true) {
			return;
		}

		if (!isAboutMoreActive) {
			TweenMax.to(bcube.position, animTime, { x: pos.x, y: pos.y, z: 0, ease: cEase })

			TweenMax.to(bcube.rotation, animTime, {
				x: 0, y: 0, z: pos.y * 3, ease: cEase,
			})
			TweenMax.to(bcube.scale, animTime, { x: 0.2, y: 0.2, z: 0.2, ease: cEase })

		} else {

			TweenMax.to(bcube.position, animTime, { x: 0, y: 1, z: 0, ease: cEase })
			TweenMax.to(bcube.rotation, animTime, { x: 0, y: 0, z: 3, ease: cEase })
			TweenMax.to(bcube.scale, animTime, {
				x: 0, y: 0, z: 0, ease: cEase,
			})
		}

	}


	let toAboutBlob = false;
	const moveToAboutBlob = function (pos) {

		toAboutBlob = true;
		if (work == true || isIntro == true || workTriangle == true) {
			return;
		}
		animateBcube = false;

		if (isAboutMoreActive) {
			if (pmaterial.opacity == 1) {
				TweenMax.to([material, pmaterial, wmaterial], animTime, {
					opacity: 0.5, ease: cEase
				});
			}
			TweenMax.to(cube.position, animTime, { x: 2, y: (parseFloat(pos.y * 1.5)), z: 0, ease: cEase })
		} else {

			if (pmaterial.opacity < 0.9) {
				TweenMax.to(pmaterial, animTime, {
					opacity: 1, ease: cEase
				});
			}

			if (cube.scale.x != 2) {
				TweenMax.to(cube.scale, animTime, {
					x: 2, y: 2, z: 2, ease: cEase,

				})
			}
			TweenMax.to(cube.position, animTime, { x: 2, y: (parseFloat(pos.y * 1.5) - 0.5), z: 0, ease: cEase })

		}


		TweenMax.to(cube.rotation, animTime, { x: pos.y, y: pos.y, z: 1, ease: cEase })
	}

	let workTriangle = false;
	const moveToWorkTriangle = function (pos) {


		if (workText == false) {
			animateBcube = true;
			workTriangle = true;
			if (pmaterial.opacity == 0.5) {
				TweenMax.to(pmaterial, animTime, {
					opacity: 1, ease: cEase
				});
			}
			if (bmaterial.opacity === 0) {
				TweenMax.to(bmaterial, animTime, {
					opacity: 1,
					delay: 0.5, ease: cEase
				});

			}

			if (material.opacity != 1) {
				TweenMax.to([material, pmaterial, wmaterial], animTime, {
					opacity: 1, ease: cEase
				});
			}

			TweenMax.to(bcube.scale, animTime, { x: 1, y: 1, z: 1, ease: cEase });
			TweenMax.to(bcube.rotation, animTime, { x: 0, y: 0, z: 0.52, ease: cEase })
			TweenMax.to(cube.scale, animTime, {
				x: .5, y: .5, z: .5, ease: cEase,
			})

			TweenMax.to(bcube.position, animTime, { x: 0, y: -(parseFloat(pos.y / 1.5)), z: 0, ease: cEase })
			TweenMax.to(cube.position, animTime, { x: 0, y: -(parseFloat(pos.y) / 3), z: 0.1, ease: cEase })

		}

	}

	let workText = false;
	const moveToWorkText = function (pos) {
		workText = true;
		animateBcube = true;
		if (contact == true) {
			return;
		}

		if (pmaterial.opacity == 0 || pmaterial.opacity == 1) {
			TweenMax.to(pmaterial, animTime, {
				opacity: 0.2, ease: cEase
			});

		}
		if (bmaterial.opacity > 0.5) {

			TweenMax.to(bmaterial, animTime, {
				opacity: 0, ease: cEase
			});
		}

		if (cube.scale.x < 0.2 || cube.scale.x > 0.2) {

			TweenMax.to(cube.scale, animTime, {
				x: 0.2, y: 0.2, z: 0.2, ease: cEase,
			})
		}


		TweenMax.to(cube.position, animTime, {
			x: pos.x, y: pos.y, z: 0, ease: cEase
		});

	}


	let throttheContact = true, contact;
	const moveToContact = function (pos) {
		contact = true;
		if (throttheContact == true) {

			throttheContact = false;

			if (pmaterial.opacity != 0 && !ismobile) {
				TweenMax.to(pmaterial, animTime, {
					opacity: 1, ease: cEase
				});

			}
			TweenMax.to(cube.scale, animTime, {
				x: 0.3, y: 0.3, z: 0.3, onComplete: function () {
					throttheContact = true;
				}, ease: cEase
			})

		}
		TweenMax.to(cube.position, animTime, { x: pos.x, y: pos.y, z: 0, ease: cEase })
	}

	const p404 = function () {
		animateBcube = true;
		TweenMax.to(cube.scale, animTime, { x: 2, y: 2, z: 2, ease: cEase })
		TweenMax.to(bcube.scale, animTime, { x: 0, y: 0, z: 0, ease: cEase })
		TweenMax.to(cube.position, animTime, { x: 0, y: 0, z: 0, ease: cEase })
	}


	var vec = new THREE.Vector3();
	var pos = new THREE.Vector3();
	let work = false;
	let items = document.querySelectorAll('[data-action]');
	let rect,
		action;
	const dispatchCanvas = (button = 'btn') => {
		items.forEach((el) => {
			action = el.getAttribute('data-action');
			rect = el.getBoundingClientRect();

			if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
				body.classList.add('a-' + action)
				vec.set(
					(rect.x / window.innerWidth) * 2 - 1,
					- (rect.y / window.innerHeight) * 2 + 1,
					0.5);
				vec.unproject(camera);
				vec.sub(camera.position).normalize();
				var distance = - camera.position.z / vec.z;
				pos = pos.copy(camera.position).add(vec.multiplyScalar(distance));

				if (action == 'intro') {
					resetMainCanvas(pos);
				}
				if (action == 'intro-blob') {
					introBlob(pos);
				}
				if (action == 'about-triangle') {
					moveToAboutTriangle(pos);
				}
				if (action == 'about-blob') {
					moveToAboutBlob(pos);
				}

				if (action == 'work-triangle') {
					moveToWorkTriangle(pos);
				}
				if (action == 'work') {
					moveToWorkText(pos);
				}
				if (action == 'contact-email') {
					moveToContact(pos);
				}
				if (action == 'p404') {
					p404();
				}
			} else {
				body.classList.remove('a-' + action);
				if (action == 'intro') {
					isIntro = false;
				}
				if (action == 'work') {
					workText = false;
				}
				if (action == 'work-triangle') {
					workTriangle = false;
				}
				if (action == 'about-triangle') {
					about = false;
				}
				if (action == 'about-blob') {
					toAboutBlob = false;
				}
				if (action == 'contact-email') {
					contact = false;
				}
			}
		})

	}

	// const fs = new fastReader('.fast-reader');

	// fs.setWpm(500)
	// fs.start();

	let isAboutMoreActive = false;
	let nodeIndex = 0;

	let canTransformY = true;

	const aboutMoreText = () => {
		isAboutMoreActive = true, nodeIndex = 0;
		document.querySelector('.about').classList.add('about--more');
			if(!canTransformY) return;

		TweenMax.to('.text--visible', 0.7,
			{
				opacity: 0,
				ease: Power2.easeOut, delay: 0
			});

		TweenMax.to('.text--invisible,.scroll-area', animTime,
			{
				opacity: 1,
				ease: Power2.easeIn, delay: 0
			});

		TweenMax.to([material, pmaterial, wmaterial], animTime, {
			opacity: 0.5, ease: cEase
		});


		let nodes = document.querySelectorAll('.text__node'),
			 shift = 0;

		const animateNodeChars = (node) => {
			if(!canTransformY) return;
			let chars = node.querySelectorAll('.char');
			TweenMax.staggerTo(chars, 0.3, { autoAlpha: 1, ease: Power2.easeOut }, 0.035, allComplete);
			function allComplete() {
				nodeIndex++;
				animateNode(nodes[nodeIndex]);
				top += (node.getBoundingClientRect().height + 30);
			if(!canTransformY) return;

				TweenMax.to(bar, 1, {
					scrollTop: top
				})
			}
		}

		let top = 0;
		let bar;
		utils.getElem('.scroll-area', (el) => {
			bar = Scrollbar.init(el, {
				damping: 0.5
			});
		})
		const animateNode = (node) => {
			if(!canTransformY) return;

			if (!node) {

				return;
			}
			TweenMax.to(node, animTime,
				{
					opacity: 1,
					ease: cEase,
					onStart: function () {
						animateNodeChars(node);

					}
				});

		}

		setTimeout(() => {
			if(!canTransformY) return;

			animateNode(nodes[nodeIndex]);
		}, 500);


	const sCotrent = document.querySelectorAll('.scroll-content')
	sCotrent.forEach(element => {
		element.addEventListener('wheel', () => {
			document.querySelector('.scroll-area').classList.add('scrolled');
			element.classList.add('scrolled')
			canTransformY = false;

		})
	});
	}

	var numRot = 0.0005, root = 0, fps = 0;
	let animateBcube = true;
	let time = 0;

	group3d.scale.x = 0;
	group3d.scale.y = 0;
	group3d.scale.z = 0;

	let animateScene = false;


	document.addEventListener('scroll', utils.throttle(function () {
		dispatchCanvas();
	}, 10));
	console.log(animTime * 1000);

	document.addEventListener('scroll', utils.debounce(function () {
		dispatchCanvas();
	}, 100));
	// document.addEventListener('scroll', utils.debounce(function () {
	// animateScene = false;
	// }, 20));
	TweenMax.to(group3d.scale, 1.2, {
		x: 1,
		y: 1,
		z: 1,
		ease: cEase,
		onComplete: function () {
			animateScene = true;
			dispatchCanvas();

		}
	});
	function animate() {
		time += 0.01;

		// Smooth camera movement based on mouse
		if (!ismobile) {
			camera.position.x += (mouseX * 0.0001 - camera.position.x) * 0.05;
			camera.position.y += (-mouseY * 0.0001 - camera.position.y) * 0.05;
			camera.lookAt(scene.position);

			// Animate particles with mouse influence
			particles.forEach((particle, index) => {
				// Floating animation
				particle.position.y += Math.sin(time * particle.userData.speed + index) * 0.001;
				particle.position.x += Math.cos(time * particle.userData.speed + index * 0.5) * 0.0005;

				// Mouse attraction effect
				const distance = particle.position.distanceTo(camera.position);
				if (distance < 5) {
					const mouseInfluence = new THREE.Vector3(
						(mouse.x * 2),
						(mouse.y * 2),
						0
					);
					particle.position.lerp(mouseInfluence, 0.002);
				}

				// Rotation
				particle.rotation.x += particle.userData.speed;
				particle.rotation.y += particle.userData.speed * 0.5;
			});

			// Enhanced group rotation
			group3d.rotation.x += numRot + targetRotationX * 0.1;
			group3d.rotation.y += numRot + targetRotationY * 0.1;
			group3d.rotation.z += numRot;

			if (animateBcube == true) {
				cube.rotation.x -= numRot * 5 + targetRotationX * 0.2;
				cube.rotation.y -= numRot * 5 + targetRotationY * 0.2;
				cube.rotation.z -= numRot * 5;
			}

			// Dynamic lighting based on mouse position
			lightFront.position.x = 10 + mouse.x * 5;
			lightFront.position.y = 10 + mouse.y * 5;
			lightBack.position.x = -5 - mouse.x * 3;
			lightBack.position.y = -10 - mouse.y * 3;

			// Pulsing light intensity
			lightFront.intensity = 1.2 + Math.sin(time * 2) * 0.3;
			lightBack.intensity = 1.2 + Math.cos(time * 1.5) * 0.3;
		}

		// Update hover effects
		updateHoverEffects();

		// Smooth rotation dampening
		targetRotationX *= 0.95;
		targetRotationY *= 0.95;

		composer.render(scene, camera);
		requestAnimationFrame(animate);
	}

	// function gotoSection(section, sectionAnimation) {
	// 	console.log(sectionAnimation);

	// 	document.documentElement.scrollTop = document.querySelector('.' + sectionAnimation).offsetTop - (window.innerHeight / 10);

	// }

	let blobBigger = false;
	const handleEvents = (params) => {

		// utils.getElem('[data-gotosection]', (el) => {
		// 	el.addEventListener('click', () => {
		// 		gotoSection(el.getAttribute('data-gotosection'), el.getAttribute('data-section'));
		// 	});
		// })

		utils.getElem('[data-click]', (el) => {
			let callback = el.getAttribute('data-click')
			el.addEventListener('click', () => {
				if (callback == 'aboutMore') {
					aboutMoreText();
				}
			})
		})

	}


	const setup = () => {
		animate();
		handleEvents();
	}
	setup();

}
